import Vue from "vue";
import {
  getOSSAuthorization
} from "@/api/upload";
import OSS from "ali-oss";

/**
 * 2020-08-18 董浩
 * 获取随机字符串
 * len：随机字符串的长度
 * */
export function randomString(len) {
  len = len || 10;
  let $chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789';
  let maxPos = $chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

/**
 * 2020-08-18 董浩
 * 医生注册、药师完善信息上传图片（临时文件会定时清理）
 * params: files(文件)；uploadImageCallBack(上传回调)；
 * 上传成功回调函数：uploadImageCallBack(failFile)
 * failFile：上传失败的文件路径数组
 * */
export function uploadImage(files, uploadImageCallBack, dir, policy) {
  if (!dir) {
  	dir = 'images';
  }
  
  if (!policy) {
  	policy = 'collect-product-images';
  }

  // 上传oss
  getOSSAuthorization(policy).then(async (response) => {
    if (response) {
      // 获取上传oss需要的client内容
      let client = new OSS({
        region: "oss-cn-zhangjiakou",
        // 云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
        accessKeyId: response.accessKeyId,
        accessKeySecret: response.accessKeySecret,
        stsToken: response.securityToken,
        bucket: "syjk-oss",
      });

      let i = 1;

      // 对象形式
      if (files.constructor == Object) {
        let successKey = {}; // 上传成功的路径
        let keys = Object.keys(files);

        for (let key of keys) {
          let res = await upload(client, files[key], dir, i);

          if (res) {
            successKey[key] = res;
          }
          else {
            successKey[key] = 'error';
          }

          if (i === keys.length) {
            if (uploadImageCallBack) {
              uploadImageCallBack(successKey, files);
            }
          }

          i ++;
        }
      }
      // 数组形式
      else {
        let successKey = []; // 上传成功的路径

        for (let file of files) {
            await upload(client, file, dir, i).then(res => {
              if (res) {
                successKey.push(res);
              }
              else {
                successKey.push('error');
              }

              if (i === files.length) {
              	if (uploadImageCallBack) {
              		uploadImageCallBack(successKey, files);
              	}
              }

              i ++;
            });
        }
      }
    } else {
      if (uploadImageCallBack) {
      	uploadImageCallBack();
      }
    }
  });
}


function upload(client, file, dir, i) {
  let picName = 'procurement/' + process.env.VUE_APP_ENVVERSION + '/' + dir + "/" + new Date().getTime() + randomString(3) + i + "." + file.name.split(".")[1];
  let urlPic = client.signatureUrl(picName);

  // 进行oss上传
  return client.put(picName, file).then(r2 => {
      // 图片压缩
      return client.processObjectSave(picName, picName, "image/quality,Q_60", "syjk-oss").then(lessenReq => {
        return picName;
      });
    })
    .catch(err => {
      return null;
    });
}
